module.exports = __webpack_public_path__ + "static/img/行业特性应用1.0b2627aa.png";